/**
 * Format address display for ADDRESS type nodes
 * @param {string} addressString - The full address string (comma-separated)
 * @returns {Object} - Object with line1 and line2 for display
 */
export const formatAddressDisplay = (addressString) => {
  if (!addressString) return { line1: addressString, line2: '' };
  
  // Split by comma and clean up parts
  const parts = addressString.split(',').map(part => part.trim());
  
  if (parts.length >= 3) {
    // Assume format: Street, City, State PostalCode, Country
    // Or: Street, City, State PostalCode
    const lastPart = parts[parts.length - 1]; // Country or State+PostalCode
    const secondLastPart = parts[parts.length - 2]; // State+PostalCode or City
    
    // Check if last part looks like a country (not numeric)
    const hasCountry = lastPart && !/^\d/.test(lastPart.trim());
    
    if (hasCountry && parts.length >= 4) {
      // Format: Street, City, State PostalCode, Country
      const streetAndCity = parts.slice(0, -2).join(', '); // Street + City
      const statePostal = secondLastPart; // State + PostalCode
      const country = lastPart; // Country
      
      return {
        line1: `${streetAndCity}, ${statePostal}`,
        line2: country
      };
    } else {
      // Format: Street, City, State PostalCode (no country)
      const streetAndCity = parts.slice(0, -1).join(', '); // Street + City
      const statePostal = lastPart; // State + PostalCode
      
      return {
        line1: streetAndCity,
        line2: statePostal
      };
    }
  }
  
  return { line1: addressString, line2: '' };
};